import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AvatarCustomStyle } from 'src/app/core/enum/styles';
import { ExternalConnectionalModalComponent } from './external-connectional-modal/external-connectional-modal.component';
import { modalConfig, ModalEnum } from 'src/app/core/util/modalConfig';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { getColorCode } from 'src/app/core/util/color';
import { SharedProjectService } from 'src/app/core/service/api/shared-project.service';
import { userRoleFinder } from 'src/app/core/util/userDropDownPermission';
import { SubprojectQuery } from 'src/app/akita/subproject/state/subprojects.query';
import { GenericComponent } from 'src/app/core/util/abstract/generic-component';

@Component({
  selector: 'app-generic-share-items',
  templateUrl: './generic-share-items.component.html',
  styleUrls: ['./generic-share-items.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericShareItemsComponent extends GenericComponent {
  loaded = signal(false);
  isProcessing = signal(false);
  isSharedSubproject = signal<boolean>(false);
  isDropdownOpen: boolean = false;
  isStatusPanleOpen: boolean = false;
  allProjects: any[] = [];
  entityProjects: any[] = [];
  selectedVisibleProjects: any[] = [];
  status = 'muted';
  statuses: any[] = [
    { labelKey: 'status_muted', value: 'muted' },
    { labelKey: 'status_accepted', value: 'accepted' },
    { labelKey: 'status_rejected', value: 'rejected' }
  ];
  @Input() entity: any;
  @Input() type: string = '';
  @Input() isReadOnly: boolean = false;
  @Output() onSelectProjects: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCreateEntity: EventEmitter<any> = new EventEmitter<any>();
  isAdmin = false;
  isReader = false;
  public AvatarCustomStyle = {...AvatarCustomStyle,"border-style": "dashed", 'border-width': '2px' ,"width": "30px", "height": "30px" };
  constructor(
    private dialog: MatDialog,
    private subProjectQuery: SubprojectQuery,
    private router: Router,
    public globals: Globals,
    private elRef: ElementRef,
    private sharedProjectService: SharedProjectService,
    private cdRef: ChangeDetectorRef
  ) {
    super(globals);
  }

  ngOnInit(): void {
    const activeSubProject = this.subProjectQuery.getActive();
    this.isSharedSubproject.set(activeSubProject && activeSubProject?.tenant_type === 'shared');
    this.isAdmin = !!this.globals.user?.isAdmin;
    this.isReader = this.computeIsReader();
    this.loaded.set(false);
    this.sharedProjectService.getSharedProjects().subscribe((projects)=>{
      this.globals.shared_projects = this.filterSharedProjectsByTypeAndModule(projects);
      let sharedProjects = this.entity?.shared_info?.shared_project ?? [];
      sharedProjects = Array.from(new Map(sharedProjects.map(proj => [proj.id, proj])).values());
      this.entityProjects = sharedProjects.map(proj => ({color: getColorCode(), ...proj}));

      this.allProjects = this.globals.shared_projects
        .filter(proj => proj.shared_level === 'read')
        .map(proj => {
          const sharedProject = sharedProjects.find(sp => sp.id === proj.id);
          const isAccepted = sharedProject?.item_status === 'accepted';
          return {
            color: getColorCode(),
            is_disabled: isAccepted,
            ...proj
          };
        })
        .filter(proj => proj.modules.some(module => module.module_id===this.type));

      const visibleIds = new Set(this.allProjects.map(p => p.id));
      this.selectedVisibleProjects = this.entityProjects.filter(p => visibleIds.has(p.id));
      this.cdRef.detectChanges()
    })
  }
  
  ngAfterViewInit(): void {
    this.loaded.set(true);
  }

  get avatarProjects(): any[] {
    if (!Array.isArray(this.entityProjects) || !Array.isArray(this.globals.shared_projects)) {
      return [];
    }
    const allowedIds = new Set(
      this.globals.shared_projects.map((p: any) => p.id)
    );
    return this.entityProjects.filter((proj: any) => allowedIds.has(proj.id));
  }

  private computeIsReader(): boolean {
    try {
      const data = this.globals.user?.scope?.data;
      if (!Array.isArray(data) || data.length === 0) return false;
      return !!userRoleFinder(this.globals);
    } catch {
      return false;
    }
  }

  toggleDropdown(){
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  
  toggleStatusDropdown(){
    this.isStatusPanleOpen = !this.isStatusPanleOpen;
  }

  openExternalConnectionalModal(){
    this.isDropdownOpen = false;
    this.dialog.open(ExternalConnectionalModalComponent, modalConfig({
      data: this.entityProjects,
      panelClass: 'custom-dialog-container',
      disableClose: false,
    }, ModalEnum.ModalSmall))
  }

  navigateToKaart(){
    const url = `/${this.router.url.split("/")[1]}/kaart`;
    if (url) {
      this.globals.toggleSlider = true;
      this.router.navigateByUrl(url);
    }
  }

  onProjectSelection(event: any){
    const visibleIds = new Set(this.allProjects.map(p => p.id));
    const hiddenExisting = (this.entityProjects || []).filter(p => !visibleIds.has(p.id));
    this.selectedVisibleProjects = event;
    this.entityProjects = [...hiddenExisting, ...event];
    this.onSelectProjects.emit(this.entityProjects);
  }

  @HostListener('document:click', ['$event'])
  closeDropdown(event: MouseEvent){
    if (this.isDropdownOpen && !this.elRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }

  onSaveItem(){
    this.isProcessing.set(true);
    this.entity.status = this.status;
    if (this.entity.status!=='muted') { 
      this.isStatusPanleOpen = false;
      this.onCreateEntity.emit({payload: this.entity});
    }
  }
}
